import {
    SORT_OPTIONS_V3,
    GROUPS_FILTRATION_DATA,
    STANDARD_LIMIT_OPTIONS,
    RARITIES_FILTRATION_DATA
} from "./global";

export const BAZAAR_TABS = {
    ITEMS: "items",
    ACTIVITY: "activity",
    TOKEN: "token",
}

export const BAZAAR_TABS_OPTION = [
    {id: BAZAAR_TABS.ITEMS, name: "itemsForSale", icon: "/images/ownedItem-tab.png"},
    {id: BAZAAR_TABS.ACTIVITY, name: "activity", icon: "/images/activity-tab.png"},
    {id: BAZAAR_TABS.TOKEN, name: "kompeteToken", icon: "/images/kompete-coin.png"},
]

export const INVENTORY_FILTRATION_DATA_BAZAAR = {
    page: {value: 1},
    orderBy: {
        data: SORT_OPTIONS_V3,
        value: SORT_OPTIONS_V3[0]
    },
    limit: {
        data: STANDARD_LIMIT_OPTIONS,
        value: STANDARD_LIMIT_OPTIONS[2],
    },
    filter: [
        RARITIES_FILTRATION_DATA,
        GROUPS_FILTRATION_DATA
    ]
}

export const ORDERS_REQUEST_DEFAULT_DATA_BAZAAR = {
    limit: 36,
    offset: 0,
    value: "",
    orderBy: SORT_OPTIONS_V3[0].value,
    groups: [],
    rarities: [],
}

export const LISTING_SIGN_TYPE = {
    LazyListing: [
        {name: "seller", type: "address"},
        {name: "tokenContract", type: "address"},
        {name: "tokenIds", type: "uint256[]"},
        {name: "amounts", type: "uint256[]"},
        {name: "price", type: "uint256"},
        {name: "paymentToken", type: "address"},
        {name: "listingType", type: "uint8"},
        {name: "desiredTokens", type: "address[]"},
        {name: "desiredTokenIds", type: "uint256[]"},
        {name: "desiredAmounts", type: "uint256[]"},
        {name: "deadline", type: "uint256"},
        {name: "referrer", type: "address"},
        {name: "nonce", type: "uint256"},
    ]
};

export const MAKE_OFFER_TYPE = {
    CollectionOffer: [
        {name: "buyer", type: "address"},
        {name: "tokenContract", type: "address"},
        {name: "tokenId", type: "uint256"},
        {name: "amount", type: "uint256"},
        {name: "price", type: "uint256"},
        {name: "paymentToken", type: "address"},
        {name: "deadline", type: "uint256"},
        {name: "nonce", type: "uint256"},
    ]
}